// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"709":"6cce4476","934":"c4d53f75"}[chunkId] + ".chunk.js";
};